import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FormEvalCompetenciaQuestionsServices from "./eval_form_compe_questions.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFormEvalCompetencias = (filters, setData, setLoader, setError) => async (dispatch) => {
  try {
    // setLoader(true)
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: true,
    });
    const resp = await FormEvalCompetenciaQuestionsServices.getFormEvalCompetenciasQuestions(filters);
    // setData(resp.data)
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: {
        evalFormCompetencyQuestion:resp.data.data,
        evalFormCompetencyQuestionState:resp.data.estado_evaluacion,
        nota: resp.data.nota_competencia,
        desempeño: resp.data.categoria_desempenio?resp.data.categoria_desempenio:""
      }, // agregar .data
    });
    // console.log("data del get", resp);
    // setError(null)
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    // setError(message)
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: message,
    });
  } finally {
    // setLoader(false)
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: false,
    });
  }
}

export const getFormEvalCompeteciaQuestionById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: true,
    });
    const resp = await FormEvalCompetenciaQuestionsServices.getFormEvalCompetenciaQuestion(id);
console.log("respuesta de action: ",  resp);
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: false,
    });
  }
};

export const saveFormEvalCompetenciaQuestion = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: true,
    });
    const resp = await FormEvalCompetenciaQuestionsServices.saveFormEvalCompetenciaQuestion(req);
    const { data, count } = getState().formEvalCompetencyQuestion.formEvalCompetencyQuestion;
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: false,
    });
  }
};

export const editFormEvalCompetenciaQuestion = (req, id, index,data,setData, setSaveLoader,setError) => async (dispatch, getState) => {
  try {
    // setSaveLoader(true)
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: true,
    });
    const resp = await FormEvalCompetenciaQuestionsServices.editFormEvalCompetenciaQuestion(id, req);
    // let _data = data;
    // _data[index]=resp.data
    const { evalFormCompetencyQuestionState } = getState().evalFormCompetencyQuestion;
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: {
        evalFormCompetencyQuestion:resp.data.data,
        evalFormCompetencyQuestionState: evalFormCompetencyQuestionState,
        nota: resp.data.nota_competencia,
        desempeño: resp.data.categoria_desempenio?resp.data.categoria_desempenio:""
      }, // agregar .data
    });
    // setData(_data)
    // dispatch({
    //   type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
    //   payload: resp.data,
    // });
    // setError("")
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    // setError(message)
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: message,
    });
  } finally {
    // setSaveLoader(false)
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: false,
    });
  }
}

export const deleteFormEvalCompetenciaQuestion = (id, index) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: true,
    });
    await FormEvalCompetenciaQuestionsServices.deleteFormEvalCompetenciaQuestion(id);
    const { data, count } = getState().formEvalCompetencyQuestion.formEvalCompetencyQuestion;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS,
      payload: false,
    });
  }
}
